<template>
  <v-row no-gutters>
    <v-col class="pa-2" cols="12" md="6">
      <div class="rowinfo">
        <v-file-input
          clearable
          dense
          label="آپلود لوگو"
          outlined
          prepend-icon=""
          prepend-inner-icon="mdi-camera"
          @change="getImg($event)"
          class="contentinfo"
        />
        <help-info
          :element-name="`${serviceName}-${componentName}-imageOptions-upload`"
          :service-name="serviceName"
          :help-data="helpData"
          class="buttoninfo"
          label="آپلود لوگو"
        />
      </div>
    </v-col>

    <v-col class="pa-2" cols="12" md="6">
      <v-checkbox
        v-model="options.imageOptions.hideBackgroundDots"
        :disabled="!options.image"
        class="ma-0"
        label="پنهان کردن نقطه های پشت لوگو"
        @change="$emit('update')"
      />
    </v-col>

    <v-col class="pa-2" cols="12" md="6">
      <v-slider
        v-model="computedImgSize"
        :disabled="!options.image"
        append-icon="mdi-image-size-select-large"
        label="سایزلوگو"
        max="10"
        min="0"
        step="1"
        thumb-label
        track-color="grey"
      >
        <template v-slot:thumb-label="{ value }">
          <div
            class="d-flex align-center justify-center"
            style="
              width: 20px;
              height: 20px;
              background-color: rgba(12, 15, 26, 0.7);
              border-radius: 50%;
            "
          >
            {{ value / 10 }}
          </div>
        </template>
      </v-slider>
    </v-col>

    <v-col class="pa-2" cols="12" md="6">
      <div class="rowinfo">
        <v-text-field
          v-model="options.imageOptions.margin"
          :disabled="!options.image"
          dense
          label="حاشیه لوگو"
          min="0"
          outlined
          class="contentinfo"
          type="number"
          @input="$emit('update')"
        />
        <help-info
          :element-name="`${serviceName}-${componentName}-imageOptions-margin`"
          :service-name="serviceName"
          :help-data="helpData"
          class="buttoninfo"
          label="حاشیه لوگو"
        />
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "qrCodeLogo",

  props: {
    value: Object,
  },

  data: () => ({
    helpData: [],
    serviceName: "Qrland",
    componentName: "qrCodeLogo",
    imgSize: 5,
  }),

  computed: {
    options: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    computedImgSize: {
      get() {
        return this.imgSize;
      },
      set(val) {
        this.imgSize = val;
        this.options.imageOptions.imageSize = val / 10;
        this.$emit("update", true);
      },
    },
  },

  methods: {
    getImg(e) {
      if (!!e) {
        const reader = new FileReader();
        reader.readAsDataURL(e);
        reader.onload = () => {
          this.options.image = reader.result;
        };
      } else {
        this.options.image = "";
      }
      this.$emit("update", true);
    },
  },
};
</script>

<style scoped></style>
